import { MeilisearchAsset } from '@/lib/meilisearch/types'
import { AssetSummary, AssetType } from '@/lib/assets/types'
import { isGraphicsCrateImage } from '@/lib/assets/assets'

export const resolveAssetType = (meilisearchAsset: MeilisearchAsset): AssetType => {
  // TODO: Add more verticals
  const vertical = meilisearchAsset.vertical

  switch (vertical) {
    case 'videos':
      return 'fc_effects'
    case 'sounds':
      return 'sc_sounds'
    case 'graphics':
      return 'gc_images'
    case '3d':
      // In this case the id should be something like 3d_object_xxx
      const parts = meilisearchAsset.id.split('_')
      const assetType = parts[1]

      if (assetType === 'object') {
        return 'rc_objects'
      }

      if (assetType === 'material') {
        return 'rc_materials'
      }

      if (assetType === 'environment') {
        return 'rc_environments'
      }

      throw new Error(`Unknown asset type for 3d category: ${vertical}`)
    default:
      throw new Error(`Unknown asset type for vertical: ${vertical}`)
  }
}

export const meilisearchVerticalToMainCategorySlug = (vertical: string): string => {
  switch (vertical) {
    case 'videos':
      return 'vfx'
    case 'sounds':
      return 'sfx'
    case 'graphics':
      return 'graphics'
    case '3d':
      return '3d'
    default:
      throw new Error(`Unknown main category type for vertical: ${vertical}`)
  }
}

export const mainCategorySlugToMeilisearchVertical = (mainCategorySlug: string): string => {
  switch (mainCategorySlug) {
    case 'vfx':
      return 'videos'
    case 'sfx':
      return 'sounds'
    case 'graphics':
      return 'graphics'
    case '3d':
      return '3d'
    default:
      throw new Error(`Unknown main category slug: ${mainCategorySlug}`)
  }
}

export const assetTypeToMeilisearchVerticalType = (assetType: AssetType): string | null => {
  switch (assetType) {
    case 'rc_objects':
      return 'object'
    case 'rc_materials':
      return 'materials'
    case 'rc_environments':
      return 'environment'
    default:
      return null
  }
}

export const meilisearchAssetToAssetSummary = (
  asset: MeilisearchAsset,
  defaults: {
    mainCategorySlug?: string | null
    categorySlug?: string | null
    subCategorySlug?: string | null
    contentSlug?: string | null
  }
): AssetSummary => {
  const __typename = resolveAssetType(asset)

  const assetSummary = {
    ...defaults,
    mainCategorySlug: defaults.mainCategorySlug ?? meilisearchVerticalToMainCategorySlug(asset.vertical), // Ensure the asset has a main category slug
    __typename,
    background: asset?.extra?.background ?? 'dark',
    dimensions: asset?.extra?.dimensions ?? '',
    file_name: asset.location,
    title: asset.title,
    location: asset.location,
    category: asset.category,
    keywords: asset.keywords,
    level: asset.level,
  }

  if (isGraphicsCrateImage(assetSummary)) {
    assetSummary.preview = asset.preview ?? ''
  }

  return assetSummary
}
